import React from 'react';

import InsightsChat from 'components/InsightsChat/InsightsChat';

// Mounts the AI Insights slideout overlay so it is available app-wide. The
// slideout is opened contextually from the Dashboard/Report toolbars (scoped to
// the viewed content); the top-level chat now lives on its own full page
// (InsightsChatNavButton), so there is no longer a visible top-bar trigger here.
const InsightsChatTrigger = () => {
  return <InsightsChat />;
};

export default InsightsChatTrigger;
